<template>
  <div id="productOverview" class="container">
    <b-button style="padding-left: 0px; padding-right: 0px; border-top: 1px solid #bfbfbf; border-radius: 0px" block variant="light" :disabled="true">
      <h4 class="float-left">
        <span id="produktmerkmaleBadgeDisabled" :class="badgeClass">3</span>
        {{ $t('product-overview.heading') + ' ' + konfigModel.i18nBenennung}}</h4>
    </b-button>
    <b-collapse id="collapseProductOverview" accordion="confiAccordion" role="tabpanel"
                v-on:shown="changeCollapseState(true)" v-on:hidden="changeCollapseState(false)">

      <b-card class="card">
        <div id="overlay" ref="overlay" v-if="isDownloading">
          <div class="loadermiddle">
            <div  class="loader">
            </div>
          </div>
        </div>
        <b-row>
          <b-col>
            <b-row style="white-space: pre-wrap; font-weight: bold">
              {{produktTextHeadline}}
            </b-row>
            <b-row style="white-space: pre-wrap">
              {{produktText}}
            </b-row>
          </b-col>
          <b-col class="flex-right; width: 50%">
            <b-row style="width: 100%; margin-bottom: 2em;">
              <strong style="margin-right: 5px">{{ $t('product-overview.partNumber') }}:</strong>
              <span v-if="ppsNr != null && lieferzustandNr != null && lieferzustandNr != 0">{{ppsNr}}-{{lieferzustandNr}}</span>
              <span v-if="ppsNr != null && lieferzustandNr === 0">{{ppsNr}}</span>
              <span v-if="ppsNr != null && lieferzustandNr == null">{{ppsNr}}, {{$t('product-overview.newDeliveryCondition')}}</span>
              <span v-if="ppsNr == null && lieferzustandNr == null">{{$t('product-overview.newPartNumber')}}</span>
            </b-row>
            <b-row v-if="!zeichnungErstellenMoeglich" style="width: 100%; margin-bottom: 2em;">
              <span>{{$t('product-overview.notAvailable')}}</span>
            </b-row>
            <b-row style="width: 100%" >
              <b-button-group style="width: 100%" vertical>

                <!-- Angebot -->
                <b-button :disabled="false" class="mayr-button-blue" v-if="kunde || anonym" v-on:click="triggerQuotationModal()">
                  <span>{{$t('quotation.quotationLong')}}</span>
                </b-button>

                <!-- Anfrage -->
                <b-button :disabled="false" class="mayr-button-blue" v-if="kunde || anonym" v-on:click="triggerInquiryModal()">
                  <span>{{$t('inquiry.inquiryLong')}}</span>
                </b-button>

                <!-- Zeichnung -->
                <b-dropdown id="generateDrawing" class="mayr-button-blue" v-if="anonym && zeichnungErstellenMoeglich" >
                  <template v-slot:button-content >
                    <b-icon icon="lock" aria-hidden="true"></b-icon> {{$t('product-overview.generateDrawing')}}
                  </template>

                  <b-dropdown-item v-on:click="showLoginModal()">{{ $t('product-overview.pdf') }}</b-dropdown-item>
                  <b-dropdown-item v-on:click="showLoginModal()">{{ $t('product-overview.tiff') }}</b-dropdown-item>
                  <b-dropdown-item v-on:click="showLoginModal()">{{ $t('product-overview.iges') }}</b-dropdown-item>
                  <b-dropdown-item v-on:click="showLoginModal()">{{ $t('product-overview.step') }}</b-dropdown-item>
                  <b-dropdown-item v-on:click="showLoginModal()">{{ $t('product-overview.dxf') }}</b-dropdown-item>
                  <b-dropdown-item  v-on:click="showLoginModal()">{{ $t('product-overview.zip') }}</b-dropdown-item>
                  <b-dropdown-item  v-on:click="showLoginModal()">{{ $t('product-overview.mail') }}</b-dropdown-item>
                </b-dropdown>

                <b-dropdown id="generateDrawing" class="mayr-button-blue" v-if="!anonym && zeichnungErstellenMoeglich">
                  <template v-slot:button-content>{{$t('product-overview.generateDrawing')}}</template>
                  <b-dropdown-item v-on:click="triggerDownload('pdf')">{{ $t('product-overview.pdf') }}</b-dropdown-item>
                  <b-dropdown-item v-on:click="triggerDownload('tiff')">{{ $t('product-overview.tiff') }}</b-dropdown-item>
                  <b-dropdown-item v-on:click="triggerDownload('iges')">{{ $t('product-overview.iges') }}</b-dropdown-item>
                  <b-dropdown-item v-on:click="triggerDownload('step')">{{ $t('product-overview.step') }}</b-dropdown-item>
                  <b-dropdown-item v-on:click="triggerDownload('dxf')">{{ $t('product-overview.dxf') }}</b-dropdown-item>
                  <b-dropdown-item  v-on:click="triggerDownload('zip')">{{ $t('product-overview.zip') }}</b-dropdown-item>
                  <b-dropdown-item  v-on:click="triggerMail()">{{ $t('product-overview.mail') }}</b-dropdown-item>
                </b-dropdown>

                <!-- SLA -->
                <!--<b-button :disabled="true" class="mayr-button-blue" v-if="!sla">
                    <b-icon icon="lock" aria-hidden="true"></b-icon> {{$t('product-overview.sla.header')}}
                </b-button>-->
                <b-button :disabled="false" class="mayr-button-blue" v-if="sla" v-b-modal.sla-modal>
                  <span>{{$t('product-overview.sla.header')}}</span>
                </b-button>
                <b-modal id="sla-modal" :title="$t('product-overview.sla.header')" ok-only>
                  <SLA :konfigModel="konfigModel" :csrfToken="csrfToken" />
                </b-modal>

                <!-- Produktmerkmale -->
                <b-button v-if="!anonym && !kunde && experte" :disabled="false" class="mayr-button-blue"
                          v-b-modal.attributes-modal @click="getItemFeatures()">
                  <span>{{$t('productAttrs.productAttributes')}}</span>
                </b-button>
                <b-modal id="attributes-modal" :title="$t('productAttrs.productAttributes')" ok-only>
                  <b-table striped hover
                           :items="itemFeatures"
                           :fields="[
                                       {key: 'name', label: $t('productAttrs.attribute')},
                                       {key: 'wert', label: $t('productAttrs.value')},
                                       {key: 'einheit', label: ''}
                                    ]"></b-table>
                </b-modal>


                <!-- Übersicht -->
                <form :action="overviewUrl" method="post" style="width: 100%" >
                  <input type="hidden" :name="csrfToken['X-CSRF-PARAM']" :value="csrfToken['X-CSRF-TOKEN']" v-if="csrfToken && csrfToken['X-CSRF-PARAM']">
                  <input type="hidden" name="konfigModel" :value="konfigModelForOverview" >
                  <b-button v-if="!anonym && !kunde" id="overviewButton" style="width: 100%" class="mayr-button-blue" type="submit" :disabled="overviewDisabled">
                    {{ $t('product-overview.overviewBtn') }}
                  </b-button>
                </form>
              </b-button-group>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <!-- Back Button -->
      <div class="float-left" style="padding-top: 15px">
        <b-button :disabled="false" variant="primary" href="#" class="mayr-button-blue"
                  v-b-toggle.collapseProductOverview.collapsePorduktmerkmale>
          <span>{{ $t('general.back') }}</span>
        </b-button>
      </div>
    </b-collapse>
  </div>

</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import url from "@/rest/url";
import SLA from "@/components/config-page/produkt/SLA";
import matomoTracking from "@/mixins/matomoTracking";

Vue.use(axios);
export default {

  name: 'ProductOverview',
  props: ['typenSchluessel', 'groesse', 'disabled', 'konfigModel',
    'csrfToken', 'produktText', 'produktTextHeadline', 'ppsNr', 'lieferzustandNr'],
  components: {SLA},
  mixins: [matomoTracking],
  data: function() {
    return {
      collapseVisible: false
    }
  },
  computed: {
    isDownloading: function () {
      return this.$store.getters.isDownloading;
    },
    badgeClass: function () {
      if (this.collapseVisible) {
        return 'badge badge-primary'
      }
      return 'badge badge-secondary'
    },
    overviewUrl: function() {
      return url.overviewURL;
    },
    konfigModelForOverview: function() {
      if (this.konfigModel && this.konfigModel.allesKonkret) {
        let data = JSON.stringify(this.konfigModel);
        return data;
      } else {
        return '';
      }
    },
    overviewDisabled: function() {
      return !this.konfigModel || !this.konfigModel.allesKonkret;
    },
    anonym: function() {
      return this.$store.getters.getUserData.anonym;
    },
    kunde: function() {
      return this.$store.getters.getUserData.kunde;
    },
    experte: function() {
      return this.$store.getters.getUserData.expertenModusErlaubt;
    },
    sla: function() {
      return this.$store.getters.getUserData.slaAnzeigenErlaubt;
    },
    zeichnungErstellenMoeglich: function () {
      if (this.konfigModel.clientOverviewModel != null && this.konfigModel.clientOverviewModel.zeichnungErstellenMoeglich) {
        return true;
      } else {
        return false;
      }
    },
    itemFeatures: function () {
      if (this.$store.getters.itemFeatures) {
        return this.$store.getters.itemFeatures;
      } else {
        return []
      }

    }
  },
  methods: {
    triggerQuotationModal() {
      this.$store.dispatch('showQuotationModal')
    },
    triggerInquiryModal() {
      this.$store.dispatch('showInquiryModal')
    },
    changeCollapseState(visible) {
      this.collapseVisible = visible;
    },
    showLoginModal(){
      this.$bvModal.show('bv-modal-login');
      this.trackEvent('Konfigurator', 'Zeichnung angefordert')
    },
    triggerDownload(filetype) {
      this.$store.dispatch('downloadDrawing', {type: filetype})
      this.trackEvent('Konfigurator', 'Zeichnung angefordert')
      this.trackEvent('Konfigurator', 'Zeichnung generiert')
    },
    triggerMail() {
      this.$store.dispatch('drawingsByMail')
      this.trackEvent('Konfigurator', 'Zeichnung angefordert')
      this.trackEvent('Konfigurator', 'Zeichnung generiert')
    },
    requestOfferModal() {
    },
    getItemFeatures() {
      this.$store.dispatch('getItemFeatures')
    },
    //onOverviewButton() {
    //    this.$store.dispatch('showOverviewWithKonfigModel')
    //}
  }
}
</script>

<style scoped>
/deep/ #generateDrawing > button{
  border-radius: 0px;
  border-color: #0093d7;
  background-color: transparent;
  color: white;
}

/deep/ #generateDrawing  > button:hover{
  background-color: #0081BD;
}
</style>
<style>

/*TODO: ist wirklich mega Kacke!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
#generateDrawing__BV_toggle_ {
  border-radius: 0px;
  background-color: #0093d7;
  border:none;
  color: #fff
}

#generateDrawing__BV_toggle_:hover {
  background-color: #0095DB;
  box-shadow: none;
}

#overlay {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 2;
  cursor: pointer;
  text-align: center;
}

</style>